@import (reference) '../../../constants/spacing.module.less';

.card-wrapper {
  gap: @space-16;
  padding: @space-24;
  border-radius: 8px;
  border: 1px solid var(--Border-Medium, var(--grey-300));
  background: var(--Surface-Container, var(--white));
}
